document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('variant-change-dropdown')) return;

const select = e.target;
const newVariantId = select.value;
const line = select.dataset.line;

const inputQty = document.querySelector('.quantity__input').value;

let productOption = document.querySelector('.product-option dd');

// ✅ selected option ka text
const selectedText = select.options[select.selectedIndex].text;

productOption.innerText = selectedText;
console.warn('inputQty:', inputQty);

  if (!newVariantId || !line) return;

  const cartItem = select.closest('li');
  cartItem?.classList.add('loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(line),
      quantity: 0
    })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: newVariantId,
        quantity: Number(inputQty)
      })
    });
  })
  .then(() => {
    return fetch('/?section_id=mini-cart');
  })
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newMiniCart = doc.querySelector('mini-cart');
    const currentMiniCart = document.querySelector('mini-cart');

    if (newMiniCart && currentMiniCart) {
      currentMiniCart.innerHTML = newMiniCart.innerHTML;
    }
  })
  .catch(err => console.error('Variant swap error:', err));
});


//-----------------------

$(document).ready(function(){

  var slider = $('.cstm_product_slider');

  slider.slick({
    dots:false,
    arrows:true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>', 
    nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    slidesToShow:4,
    slidesToScroll:1,
    responsive:[
      {
        breakpoint:1024,
        settings:{ slidesToShow:3 }
      },
      {
        breakpoint:750,
        settings:{
          slidesToShow:1,
          centerMode:true,
          centerPadding:'120px'
        }
      }
    ]
  });

  // 👇 Image area par swipe kare to card slider disable
  $(document).on('mouseenter touchstart', '.product-media-wrapper', function(){
    slider.slick('slickSetOption','swipe', false, true);
  });

  // 👇 Image area se bahar aaye to card slider enable
  $(document).on('mouseleave touchend', '.product-media-wrapper', function(){
    slider.slick('slickSetOption','swipe', true, true);
  });

});


(function () {
  const drawerButton = document.querySelector(".bottom-nav-item.cart_drawer_original");
  console.log('1...')
  if (drawerButton) {
    const drawer = document.querySelector("mini-cart");
  console.log('2...')

    if (drawer) {
  console.log('3...')

      drawerButton.addEventListener("click", function(e) {
  console.log('4...')

        e.preventDefault();
        drawer.open();
      });
    }
  }
  const menuDrawerButton = document.querySelector(".bottom-nav-item.menu-drawer-container");
  if (menuDrawerButton) {
    const headerDrawer = document.querySelector("header header-drawer summary");
    if (headerDrawer) {
      menuDrawerButton.addEventListener("click", function(e) {
        e.preventDefault();
        headerDrawer.click();
      });
    }
  }
  
  const loginButton = document.querySelector(".bottom_nav-login-button");
  if (loginButton) {
    loginButton.addEventListener("click", function () {
      if (document.querySelector("#CusloginModal")) document.querySelector("#CusloginModal").style.display = "none";
      if (document.querySelector(".otp_overlay")) document.querySelector(".otp_overlay").style.display = "block";
      if (document.querySelector(".main_otp_container")) document.querySelector(".main_otp_container").style.display = "block";
      window.scrollTo(0,0);
    });
  }
  const walletButton = document.querySelector(".wallet_drawer_original");
  if (walletButton) {
    walletButton.addEventListener("click", function () {
      if (document.querySelector("#CusloginModal")) document.querySelector("#CusloginModal").style.display = "none";
      if (document.querySelector(".otp_overlay")) document.querySelector(".otp_overlay").style.display = "block";
      if (document.querySelector(".main_otp_container")) document.querySelector(".main_otp_container").style.display = "block";
      window.scrollTo(0,0);
    });
  }
})();



document.addEventListener("DOMContentLoaded", function () {
  const productLinks = document.querySelectorAll('#product-grid a[href*="/products/"]');

  productLinks.forEach(link => {
    link.addEventListener("click", function () {
      const card = link.closest('.grid__item');
      if (card && card.id) {
        sessionStorage.setItem("lastProductId", card.id);
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const lastProductId = sessionStorage.getItem("lastProductId");

  if (lastProductId) {
    const el = document.getElementById(lastProductId);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({
          behavior: "auto",
          block: "center"
        });
      }, 400);
    }

    sessionStorage.removeItem("lastProductId");
  }
});
